export interface MockDashboardMetrics {
  totalUsers: number;
  activeUsers: number;
  revenue: number;
  systemStatus: 'healthy' | 'degraded' | 'down';
}

export interface MockActivity {
  id: string;
  action: string;
  timestamp: string;
  user: string;
  details?: string;
}

export interface MockDashboardData {
  metrics: MockDashboardMetrics;
  recentActivity: MockActivity[];
}

export const mockDashboardData: MockDashboardData = {
  metrics: {
    totalUsers: 12543,
    activeUsers: 8432,
    revenue: 145000,
    systemStatus: 'healthy',
  },
  recentActivity: [
    {
      id: 'act-1',
      action: 'user_login',
      timestamp: new Date(Date.now() - 1000 * 60 * 5).toISOString(), // 5 mins ago
      user: 'Demo User',
      details: 'Successful login from London, UK',
    },
    {
      id: 'act-2',
      action: 'settings_update',
      timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30 mins ago
      user: 'Demo User',
      details: 'Changed theme preference to Dark Mode',
    },
    {
      id: 'act-3',
      action: 'app_launch',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
      user: 'Alice Smith',
      details: 'Launched Dashboard Application',
    },
    {
      id: 'act-4',
      action: 'system_alert',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(), // 5 hours ago
      user: 'System',
      details: 'Scheduled maintenance completed',
    },
  ],
};
